import { render } from "./ProposalsTableComponent.vue?vue&type=template&id=3d50364f&scoped=true"
import script from "./ProposalsTableComponent.vue?vue&type=script&lang=js"
export * from "./ProposalsTableComponent.vue?vue&type=script&lang=js"

import "./ProposalsTableComponent.vue?vue&type=style&index=0&id=3d50364f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d50364f"]])

export default __exports__